import { FC, ReactNode, createContext, useState } from "react";

// Define the shape of the context
interface State {
  value: number;
}

interface ContextProps {
  state: any;
  setAPIError: (response: any) => void;
}

// Create a context with default values
const APIFailureContext = createContext<ContextProps | undefined>(undefined);

// Create a provider component
const APIFailureProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [state, setState] = useState<any>(undefined);

  const setAPIError = (response: any) => {
    setState(response);
  };

  return <APIFailureContext.Provider value={{ state, setAPIError }}>{children}</APIFailureContext.Provider>;
};

export { APIFailureContext, APIFailureProvider };
